import React, { useEffect, useState } from 'react';
import { animatedVideosList } from '../../api/apiHandler';
import { Loading } from '../../components/loading/loading';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import '../../i18';

const AnimationVideos = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [animatedVideos, setAnimatedVideos] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        const fetchAnimatedVideos = async () => {
            try {
                if (!hasMounted) setIsLoading(true);
                await getAnimatedVideos();
            } catch (error) {
                console.error('Error fetching About Us:', error);
            } finally {
                if (!hasMounted) setIsLoading(false);
                setHasMounted(true);
            }
        };
        fetchAnimatedVideos();
    }, [pageToken]);

    const getAnimatedVideos = async () => {
        const response = await animatedVideosList({
            limit: 5,
            page: pageToken,
            // sort: "id:asc"
        });
        if (response.code === 200) {
            setAnimatedVideos(response?.data?.data || []);
            setSelectedVideo(response?.data?.data[0]?.video_file);
            setTotalPage(response.data.paging);
        }
    };

    const handleVideoSelect = (videoUrl) => {
        setSelectedVideo(videoUrl);
    };

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    }

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="PageTitleBox">
                            <h2 className="PageTitleHeading">{t('animationVideosHeading')}</h2>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="course-details-content">
                            <ul className="course-details-content-ul">
                                {animatedVideos.map((video, index) => {
                                    const baseIndex = (pageToken - 1) * 5;
                                    return (
                                        <li className="course-details-content-li" key={video.id}>
                                            <a
                                                className="course-details-content-link"
                                                onClick={() => handleVideoSelect(video?.video_file)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div className="CourseLinkOne">
                                                    <span className="CourseNumber">{baseIndex + index + 1}</span>
                                                    <div>
                                                        <p className="Coursename">{video?.title}</p>
                                                        <p className="CourseTime">{video.duration || "N/A"}</p>
                                                    </div>
                                                </div>
                                                <div className="CoursePlayBtn">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/img/icon/playicon.svg`}
                                                        alt="play icon"
                                                        className="img-cover"
                                                    />
                                                </div>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="course-course-detaila-inner">
                            <div className="thumb">
                                {selectedVideo ? (
                                    <iframe
                                        width={560}
                                        height={315}
                                        src={selectedVideo}
                                        title="Video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    />
                                ) : (
                                    <p>{t('selectVideoToPlay')}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <ReactPaginate
                        className='pagination mt-4'
                        breakLabel="..."
                        nextLabel={`${t('next')} >`}
                        previousLabel={`< ${t('Previous')} `}
                        renderOnZeroPageCount={null}
                        onPageChange={handlePageClick}
                        pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                    />
                </div>
            </div>
        </div>
    );
};

export default AnimationVideos;